import type {TourOperatorSpecials} from '@/redux/v1/hotels/list/models';

import {useTranslation} from 'react-i18next';

import {PromotionBadge} from '@/components/PromotionBadge';
import {
  PROMOTION_CATEGORY_FLEX,
  PROMOTION_CATEGORY_SAFETY,
  PROMOTION_CATEGORY_SPECIAL,
} from '@/redux/v1/models';

const DISPLAY_PRIORITY = [
  PROMOTION_CATEGORY_SPECIAL,
  PROMOTION_CATEGORY_FLEX,
  PROMOTION_CATEGORY_SAFETY,
];

type Props = {
  promotions?: null | TourOperatorSpecials;
};

export const PromotionBadges: React.FunctionComponent<Props> = ({
  promotions,
}) => {
  const {t} = useTranslation('general');

  if (!promotions) {
    return null;
  }

  const categories = DISPLAY_PRIORITY.filter(
    (categoryId) => promotions[categoryId]?.length > 0
  );

  if (categories.length === 0) {
    return null;
  }

  return categories.map((category) => (
    <PromotionBadge
      key={category}
      category={category}
      tooltip={t(`promotionCategoryDescription.${category}`)}
    />
  ));
};
